export { default } from './UnscoredCategoryPageFaqsSection'
